"use client";

import type { StaticImageData } from "next/image";

import NextImage from "next/image";
import React from "react";
import { cn } from "@onclicks/sharedcomponents/ui";

import type { Props as MediaProps } from "../../types/Media";

export const ImageMedia: React.FC<MediaProps> = (props) => {
  const {
    alt: altFromProps,
    fill,
    imgClassName,
    priority,
    resource,
    size: sizeFromProps,
    src: srcFromProps,
    loading: loadingFromProps,
  } = props;

  let width: number | undefined;
  let height: number | undefined;
  let alt = altFromProps;
  let src: StaticImageData | string = srcFromProps || "";

  if (!src && resource && typeof resource === "object") {
    const {
      alt: altFromResource,
      height: fullHeight,
      url,
      width: fullWidth,
    } = resource;

    width = fullWidth!;
    height = fullHeight!;
    alt = altFromResource || "";

    const cacheTag = resource.updatedAt;

    src = `${url}?${cacheTag}`;
  }

  const loading = loadingFromProps || (!priority ? "lazy" : undefined);

  // `sizes` decrit la largeur d'AFFICHAGE de l'image, en longueurs CSS (px, vw,
  // rem). L'ancien defaut generait des descripteurs `w` (`(max-width: 640px)
  // 1280w`), qui ne sont pas des longueurs valides : le navigateur rejetait
  // toutes les entrees et retombait sur 100vw, donc telechargeait une image
  // pleine largeur de viewport meme pour un logo de 136px. On assume ce 100vw
  // explicitement ; les appelants dont l'image n'occupe pas toute la largeur
  // doivent passer `size` (cf. Header, Heros, Partners).
  const sizes = sizeFromProps ?? "100vw";

  return (
    <div className="flex">
      <NextImage
        alt={alt || ""}
        className={cn(imgClassName)}
        fill={fill}
        height={!fill ? height : undefined}
        priority={priority}
        quality={75}
        loading={loading}
        sizes={sizes}
        src={src}
        width={!fill ? width : undefined}
      />
    </div>
  );
};
